import "./about.css";
import ngo1 from "../../img/ngo1.png";

const About = () => {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img
            src="https://images.unsplash.com/photo-1617450365226-9bf28c04e130?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8bmdvfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
            alt=""
            className="a-img"
          />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Us</h1>
        <p className="a-sub">
          Following a lifecycle approach, Smile Foundation, among the top NGO in
          India, works intensively through focused welfare projects in four
          major area
        </p>
        <p className="a-desc">
          An Indian social development organization, is directly benefitting
          over 15 lakh children and their families every year. We have more than
          400 live welfare projects on education, healthcare, livelihood, and
          women’s empowerment in over 2,000 remote villages and urban slums
          across 25 states of India.
        </p>
        <div className="a-award">
          <img src={ngo1} alt="" className="a-award-img" />
          <div className="a-award-texts">
            <h2 className="a-award-title">Our Funding comes from</h2>
            <p className="a-award-desc">
              United Nations Democracy Fund (UNDEF), United Nations Women,
              Swades, Foundation P4G – Partnering for Green Growth and the
              Global Goals 2030
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
